/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { tableSchema } from "./tableSchema.ts";

export const orgUnitTableListPathOrgUnitIdSchema = z.uuid();

export const orgUnitTableListStatus200Schema = z.array(tableSchema);

export const orgUnitTableListResponseSchema = orgUnitTableListStatus200Schema;
